export enum ExternalTransactionStatus {
  IGNORED = 'IGNORED',
  HELD = 'HELD',
  MATCHED = 'MATCHED',
  UNMATCHED = 'UNMATCHED',
}

export enum ExternalDataSourceType {
  CUSTODY = 'CUSTODY',
  TRADING = 'TRADING',
}

export interface CounterParty {
  id: number
  shortName?: string
  name: string
  active?: boolean
  dtc?: number
  institutionId?: number
  agentId?: number
}

export interface TransactionTypeLabel {
  id?: number
  label?: string
  description?: string
}

export type ExternalTransactionAvailableActions =
  | 'hold'
  | 'unhold'
  | 'ignore'
  | 'unignore'
  | 'delete'
  | 'match'
  | 'matchUsingExternal'
  | 'unmatch'
  | 'post'

/**
 * Returns a unique row id for the given external transaction
 */
export function getUniqueRowIdFromExtTran({
  extTranId,
  accountId,
}: ExternalTransaction) {
  return getUniqueRowId(extTranId, accountId)
}
/**
 * Returns a unique row id for the given extTranId and accountId
 */
export function getUniqueRowId(extTranId: number, accountId: number) {
  return `${extTranId}-${accountId}`
}

export interface ExternalTransaction {
  prometheusJson: {
    aggInfo?: {
      collateralBroker?: string
      DataMap?: {
        balanceToAdjust?: string
        loanFeeType?: string
        interestBearingInterestReserve?: number
        interestBearingPrincipalReserve?: number
        nonInterestBearingInterestReserve?: number
        nonInterestBearingPrincipalReserve?: number
      }
    }
  }
  extTranId: number
  reconDate: string
  accountId: number
  rowId: string

  accountName?: string
  dataSource?: string
  dataSourceType?: ExternalDataSourceType

  tranTypeCode?: string
  tranTypeCodeName?: string
  tradeDate?: string
  settleDate?: string
  postDate?: string
  units?: number
  amount?: number
  price?: number
  accrued?: number
  commission?: number
  originationFee?: number
  exitFee?: number
  exitFeeReceivable?: number
  drawFee?: number
  prepaymentPenaltyFee?: number
  delinquencyFee?: number
  modificationFee?: number
  miscellaneousFee?: number
  prepaidInterest?: number
  interestDue?: number
  interestBearingInterestReserve?: number
  interestBearingPrincipalReserve?: number
  nonInterestBearingInterestReserve?: number
  nonInterestBearingPrincipalReserve?: number
  balanceToAdjust?: string
  loanFeeType?: string
  fee?: number
  description?: string
  executionId?: number
  executionType?: string
  basis?: string[]

  securityId?: number
  secIdentifier?: string
  cwanIdentifier?: string
  secCusip?: string
  secIsin?: string
  secFigi?: string
  secSedol?: string
  securityTypeCode?: string
  currencyCode?: string

  externalSecIdentifier?: string
  externalSecAltIdentifier?: string
  externalSecAltIdDesc?: string
  externalSecDesc?: string
  externalCusip?: string

  aggInfoString?: string

  cwLotId?: number
  fromUnits?: number
  fromAmount?: number
  exchangeRate?: number

  typeLabel?: string
  contractIdentifier?: string

  status?: ExternalTransactionStatus
  statusChangedBy?: number
  availableActions: ExternalTransactionAvailableActions[]
  originId?: number
  factor?: number

  inventoryType?: string
  counterPartyName?: string
  clearwaterCounterParty?: CounterParty
  fromSecurityId?: number
  fromAlternateId?: string
  prometheusTranId?: number
  cwTranIds?: string[]

  predictedActionProbability?: number
  predictedAction?: string
  collateralBroker?: string
  isCapitalize?: boolean
  custodyLotIdentifier?: string
  transactionTypeLabel?: TransactionTypeLabel
}
